import * as model from "../../models";
import { ShoppingCartActions } from "./shopping-cart.actions"
import { BoxOfficeActions } from "../box-office/ngrx/box-office.actions"
import { CheckoutActions } from "../../actions";

export interface ShoppingCartState {
	loaded: boolean;
	loading: boolean;
	errors: boolean;
	shoppingCart: model.ShoppingCart;
	displayShoppingCart: model.DisplayShoppingCart;
	orderComment: string;
};

const initialState: ShoppingCartState  = {
	loaded: false,
	loading: false,
	errors: false,
	shoppingCart: null,
	displayShoppingCart: null,
	orderComment: ''
}

export const shoppingCartReducer = (state: ShoppingCartState = initialState, action): ShoppingCartState => {

	switch (action.type) {
		case ShoppingCartActions.CREATE_SHOPPINGCART_SUCCESS:
			return Object.assign({}, state, { shoppingCart: action.payload })

		case ShoppingCartActions.GET_MY_SHOPPINGCART_SUCCESS:
			return Object.assign({}, state, { shoppingCart: action.payload })

		case BoxOfficeActions.GET_MY_SHOPPINGCART_SUCCESS_BO:
			return Object.assign({}, state, { shoppingCart: action.payload })

		case ShoppingCartActions.ADD_TICKETS_SUCCESS:
			return Object.assign({}, state, { shoppingCart: action.payload })

		case ShoppingCartActions.GET_DISPLAY_SHOPPINGCART_SUCCESS:
			return Object.assign({}, state, { displayShoppingCart: action.payload })

		case ShoppingCartActions.REMOVE_TICKET_SUCCESS:
			return Object.assign({}, state, { shoppingCart: action.payload });

		case ShoppingCartActions.REMOVE_TICKETS_SUCCESS:
			return Object.assign({}, state, { shoppingCart: action.payload });

		case ShoppingCartActions.ORDER_COMMENT_CHANGED:
			return Object.assign({}, state, {orderComment: action.payload});

		case BoxOfficeActions.DELETE_SHOPPINGCART_BO:
			return Object.assign({}, state, { shoppingCart: initialState.shoppingCart });

		case BoxOfficeActions.SET_HAS_ERRORS_BO: {
			return Object.assign({}, state, {
				errors: true
			})
		}

		case BoxOfficeActions.UNSET_HAS_ERRORS_BO: {
			return Object.assign({}, state, {
				errors: false
			})
		}

		case CheckoutActions.ORDER_PLACED: {
			return Object.assign({}, state, {
				orderComment: initialState.orderComment
			})
		}

		default:
			return state

	}

}



// WEBPACK FOOTER //
// ./src/app/components/shopping-cart/shopping-cart.reducer.ts